import Logo from './Logo.styled'

export default Logo
